import {ActionTypes} from './../../cc-imports'
import _ from 'lodash'
import {CCUtils, Constants, DataActionTypes} from "../../cc-imports";

const initialState = {
    byId: {},
    byUserId :{},

    pages: {},
    reqStatus: '',
    error: '',
    random: 0,
    type: DataActionTypes.GET,
    unseenCount: 0,

};


const processData = (oldState, newNtfns,type, userId)=>{

    const byId = _.keyBy(newNtfns, 'id');
    var existingById = oldState.byId ? oldState.byId : [];
    existingById = _.merge({}, existingById, byId);

    var byUserId = CCUtils.groupByGetIds(newNtfns, 'receiver','id');
    byUserId = type==DataActionTypes.PAGINATE ?  _.mergeWith({},oldState.byUserId, byUserId, CCUtils.customArrMerger):  _.mergeWith({}, byUserId, oldState.byUserId, CCUtils.customArrMerger);

    var pages = oldState.pages;


    if(userId) {

        var ntfns = _.orderBy(byUserId[userId], [(ntfn) => {
            if (existingById[ntfn]) {
                return new Date(existingById[ntfn].createdDate)
            }
            else {
                return new Date()
            }
        }], ['desc']);
        byUserId[userId]=ntfns;

        if(pages[userId]==undefined){
            pages[userId]=0;
        }

        if(type==DataActionTypes.PAGINATE || type==DataActionTypes.GET){
            pages[userId]=pages[userId]+1;
        }
    }

    return {
        byId: existingById,
        byUserId: byUserId,
        pages : pages
    }
};


const NotificationsReducers = (state = initialState, action = {}) => {

    switch (action.type) {
        case (ActionTypes.NOTIFICATION_UPDATED):
            const {type, userId} = action.meta;
            return { ...state, ...processData(state, [action.payload],type, userId)}
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_NOTIFICATIONS)):

            return {
                ...state,
                reqStatus: Constants.reqStatus.SUC,
                type: action.meta.type,
                random: Math.random(),
                ...processData(state,action.payload.data.item,action.meta.type, action.meta.id)
            }
            break;


        case (ActionTypes.getFulfilled(ActionTypes.GET_NOTIFICATIONS)):
            return {
                ...state,
                reqStatus: action.meta.type == DataActionTypes.PAGINATE ? Constants.reqStatus.COM : Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;

        case (ActionTypes.getPending(ActionTypes.GET_NOTIFICATIONS)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.PEN,
                type: action.meta.type
            }
            break;

        case (ActionTypes.getRejected(ActionTypes.GET_NOTIFICATIONS)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;

        // TODO:  want to update
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_NOTIFICATION)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.SUC,
                type: action.meta.type,
                random: Math.random(),
                ...processData(state,[action.payload.data.item],action.meta.type, action.meta.id)
            }
            break;

        case (ActionTypes.getFulfilled(ActionTypes.GET_NOTIFICATION)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;

        // TODO:  want to update
        case (ActionTypes.getPending(ActionTypes.GET_NOTIFICATION)):
            return {
                ...state,
                reqStatus: Constants.reqStatus.PEN,
                type: action.meta.type
            }
            break;

        case (ActionTypes.getRejected(ActionTypes.GET_NOTIFICATION)):
            return {...state,
                reqStatus: Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;


        case (ActionTypes.getCCFulfilled(ActionTypes.GET_UNSEEN_COUNT)):
            return {...state, unseenCount: action.payload.data.item.counts}
            break;

        case (ActionTypes.getCCFulfilled(ActionTypes.GET_UNSEEN_COUNT)):
            return {...state, unseenCount: action.payload.data.item.counts}
            break;

        case ActionTypes.SIGN_OUT_USER:
            return initialState;
            break;

        case ActionTypes.CLOSE_MODAL:
            return {...state, pages:{}};

        default :
            return state;
    }
};

export default NotificationsReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/NotificationsReducers.js